import PropTypes from "prop-types";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function TopBack({ backLocation = null, onBack = null }) {
    const { t } = useTranslation("topBar");
    const history = useHistory();

    const handleBack = () => {
        if (onBack) {
            onBack();
            return;
        }

        if (backLocation) {
            history.push(backLocation);
            return;
        }

        history.goBack();
    };

    return (
        <Button
            shape="round"
            icon={<ArrowLeftOutlined />}
            onClick={handleBack}
            className="!h-10 shrink-0 !border !border-[#5D5DF6]/15 !bg-[#F2F2FA] !px-4 !text-sm !font-medium !text-[#2F2F46] hover:!border-[#5D5DF6]/30 hover:!bg-[#F2F2FA] hover:!text-[#5D5DF6]">
            {t("goBack")}
        </Button>
    );
}

TopBack.propTypes = {
    backLocation: PropTypes.string,
    onBack: PropTypes.func,
};
